
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';
import { Report } from '@/types/report';
import { PreviousReportTableRow } from './PreviousReportTableRow';

interface PreviousReportTableProps {
  reports: Report[];
  onTogglePin: (report: Report) => void;
  onSelectReport: (reportId: string) => void;
}

export const PreviousReportTable: React.FC<PreviousReportTableProps> = ({ 
  reports,
  onTogglePin,
  onSelectReport
}) => {
  const [selectedReportId, setSelectedReportId] = useState<string | null>(null);

  const handleRowClick = (reportId: string) => {
    setSelectedReportId(reportId === selectedReportId ? null : reportId);
  };

  const handleConfirmSelection = () => {
    if (selectedReportId) {
      onSelectReport(selectedReportId);
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="max-h-[50vh] overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead></TableHead> {/* Column for pin button */}
              <TableHead>วันที่</TableHead>
              <TableHead>นักเรียน</TableHead>
              <TableHead>วิชา</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {reports.map((report) => (
              <PreviousReportTableRow 
                key={report.id}
                report={report} 
                onTogglePin={onTogglePin}
                isSelected={report.id === selectedReportId}
                onRowClick={handleRowClick}
              />
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="mt-6 flex justify-center">
        <Button 
          onClick={handleConfirmSelection} 
          disabled={!selectedReportId}
          className="w-full md:w-auto flex items-center justify-center gap-2"
        >
          <Check className="h-4 w-4" />
          ใช้ข้อมูลที่เลือก
        </Button>
      </div>
    </div>
  );
};
